module.exports = __webpack_public_path__ + "static/media/Klinicq_logo.70d26271.webp";